export enum TransformationType {
  TypeTransformation = 'type_transformation',
  ColumnTransformation = 'column_transformation',
  ValueTransformation = 'value_transformation',
}
